import React from 'react';
import axios from 'axios'
import { Table, Input, Button,Tooltip,Popover,Popconfirm,message,DatePicker,Descriptions,Modal,Spin,Tabs,Collapse,Form,Switch, Card } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon from '@ant-design/icons';
import { SearchOutlined,DeleteOutlined,MailFilled,DownloadOutlined,PlusOutlined,PrinterOutlined,FundViewOutlined,EditOutlined,CloseCircleOutlined,WalletFilled,LoadingOutlined,FilePdfFilled } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import CurrencyFormat from 'react-currency-format';
import * as serverconfig from '../serverconn'
import * as reactstrp from 'reactstrap';
import ReactToPrint from 'react-to-print';
import {
  Col,
  Row,
} from 'reactstrap';
import  LoanRepaymentDirectViewList from './LoanRepaymentDirectViewList'
import ReactExport from "@ibrahimrahmani/react-export-excel";
import  LoanFineAttachmentForm from '../components/LoanFineAttachmentForm'
import  LoanDateUpdateForm from '../components/LoanDateUpdateForm'
import  LoanInterestWaiverForm from '../components/LoanInterestWaiverForm'
import LoanInterestWaivingForm_MultiCycles from './LoanInterestWaivingForm_MultiCycles';
import LoanBadDebtPayOffForm from './LoanBadDebtPayOffForm';
import LoanQuickActions from './LoanQuickActions';

var CryptoJS = require("crypto-js");

const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const dateFormat = 'DD/MM/YYYY';
const { RangePicker } = DatePicker;


function callback(key) {
  console.log(key);
}

const { TabPane } = Tabs;
const FormItem=Form.Item;

var sacco= ''
var bizuserid= ''
var token= ''


class ReceiptToPrint extends React.Component {

  state = {
    companyprofile:{}
  };

  componentDidMount(){
    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
    }else{
       sacco= ''
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
    .then(res => {  
        this.setState({
          companyprofile: res.data
        })

    })

  }

//calculate principleTotal
calculateScheduleTotal=()=>{
  var principleTotal=0
  this.props.loanschedule.map(
    (item)=>{
      principleTotal+=Number(item.principle)
    })

  return principleTotal;
}

  //calculate principleTotal
  calculateInterestTotal=()=>{
    var InterestTotal=0
    this.props.loanschedule.map(
      (item)=>{
        InterestTotal+=Number(item.interest)
      })

    return InterestTotal.toFixed(2);
  }

  //calculate principleTotal
  calculateTotalPay=()=>{
    var TotalPay=0
    this.props.loanschedule.map(
      (item)=>{
        TotalPay+=Number(item.total)
      })

    return TotalPay.toFixed(2);
  }



  render() {
    return (
      <div style={{padding:20}}>
            
      <Row> 
                <Col xs="2" sm="2" lg="2">
                <img height="100" width="120"  alt="Logo" src={this.state.companyprofile.sacco_logo} />
              
                  </Col>
                  <Col xs="6" sm="6" lg="6">
                  <h3>{this.state.companyprofile.sacco_name}</h3>
                  <h6>Tel: {this.state.companyprofile.RegisteredPhoneNumber1}
                  {
                  this.state.companyprofile.RegisteredPhoneNumber2==""?
                  "":","+this.state.companyprofile.RegisteredPhoneNumber2
                  }
                  {
                  this.state.companyprofile.RegisteredPhoneNumber3==""?
                  "":","+this.state.companyprofile.RegisteredPhoneNumber3
                  }
                  </h6>               
                  <h5>Email: {this.state.companyprofile.company_email}</h5>
                  <h5>Wesite: {this.state.companyprofile.website}</h5>
                  <h5>{this.state.companyprofile.box_number}</h5>

                  </Col>

              </Row>
                  <h3 style={{fontWeight:'bolder',display: 'flex',justifyContent:'center', alignItems:'center'}}> LOAN SCHEDULE </h3>
                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}> LOAN NUMBER:  {this.props.loanissueobject.loan_number} </h4>

                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}> ACCOUNT NUMBER:  {this.props.loanissueobject.accountNumber} </h4>
                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}> ACCOUNT NAME:  {this.props.loanissueobject.accountName} </h4>

                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}> AMOUNT: <CurrencyFormat value={this.props.loanissueobject.approved_amount} displayType={'text'} thousandSeparator={true}/> UGX</h4>
                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}> PERIOD: {this.props.loanissueobject.loan_period} MONTHS</h4>
                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}>GRACE PERIOD: {this.props.loanissueobject.grace_period} DAYS</h4>

                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}>ANNUAL INTEREST RATE: {this.props.loanissueobject.interest_rate}</h4>
                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'end'}}> DATE OF ISSUANCE: {this.props.loanissueobject.date}</h4>

           <reactstrp.Table bordered>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Date</th>
                            <th>Principle Bf</th>
                            <th>Principle Pay</th>
                            <th>Interest Pay</th>
                            <th>Total Pay</th>
                            <th>Principle Bal</th>
                          </tr>
                        </thead>
                        <tbody>
                        {this.props.loanschedule.map(
                          (item)=>(
                            <tr>
                            <td>{item.repayment_number}</td>
                            <td>{item.date}</td>
                            <td>{<CurrencyFormat value={item.principlebroughtforward} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td>{<CurrencyFormat value={item.principle} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td>{<CurrencyFormat value={item.interest} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td>{<CurrencyFormat value={item.total} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td>{<CurrencyFormat value={item.balance} displayType={'text'} thousandSeparator={true}/>}</td>
                            </tr>
                          ))}
                          <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td style={{fontWeight:'bold'}}>{<CurrencyFormat value={this.calculateScheduleTotal()} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td style={{fontWeight:'bold'}}>{<CurrencyFormat value={this.calculateInterestTotal()} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td style={{fontWeight:'bold'}}>{<CurrencyFormat value={this.calculateTotalPay()} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td></td>
                          </tr>

                      </tbody>
                  </reactstrp.Table>   

                                  <br></br>
                <h3>Generated by: {CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)}</h3>
                <h3>Powered by: www.pitech.co.ug</h3>        

    </div>
    );
  }
}


class StatementToPrint extends React.Component {

  state = {
    companyprofile:{}
  };

  componentDidMount(){
    if(localStorage.getItem("sacco")){
      sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
   }else{
      sacco= ''
   }
   
   if(localStorage.getItem("token")){
      token= localStorage.getItem("token")
   }else{
      token= ''
   }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
    .then(res => {  
        this.setState({
          companyprofile: res.data
        })

    })

  }
 //calculate principle paid
 calculateTotalPrinciplePaid=()=>{
  var TotalPay=0
  this.props.loanrepayments.map(
    (item)=>{
      TotalPay+=Number(item.principle_paid)
    })

  return TotalPay.toFixed(2);
 }

  //calculate Interest paid
  calculateTotalInterestPaid=()=>{
    var TotalPay=0
    this.props.loanrepayments.map(
      (item)=>{
        TotalPay+=Number(item.interest_paid)
      })

    return TotalPay.toFixed(2);
   }

         //calculate Total total paid
  calculateTotalTotalPaid=()=>{
    var TotalPay=0
    this.props.loanrepayments.map(
      (item)=>{
        TotalPay+=Number(item.total_paid)
      })

    return TotalPay.toFixed(2);
   }

   //calculate total fine paid
   calculateTotalFinePaid=()=>{
    var TotalPay=0
    this.props.loanrepayments.map(
      (item)=>{
        TotalPay+=Number(item.fine_paid)
      })

    return TotalPay.toFixed(2);
   }


  render() {
    return (
      <div style={{padding:20}}>
            
      <Row> 
                <Col xs="2" sm="2" lg="2">
                <img height="100" width="120"  alt="Logo" src={this.state.companyprofile.sacco_logo} />
              
                  </Col>
                  <Col xs="6" sm="6" lg="6">
                  <h3>{this.state.companyprofile.sacco_name}</h3>
                  <h6>Tel: {this.state.companyprofile.RegisteredPhoneNumber1}
                  {
                  this.state.companyprofile.RegisteredPhoneNumber2==""?
                  "":","+this.state.companyprofile.RegisteredPhoneNumber2
                  }
                  {
                  this.state.companyprofile.RegisteredPhoneNumber3==""?
                  "":","+this.state.companyprofile.RegisteredPhoneNumber3
                  }
                  </h6>               
                  <h5>Email: {this.state.companyprofile.company_email}</h5>
                  <h5>Wesite: {this.state.companyprofile.website}</h5>
                  <h5>{this.state.companyprofile.box_number}</h5>

                  </Col>

              </Row>
                  <h3 style={{fontWeight:'bolder',display: 'flex',justifyContent:'center', alignItems:'center'}}> LOAN STATEMENT </h3>
                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}> LOAN NUMBER:  {this.props.loanissueobject.loan_number} </h4>

                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}> ACCOUNT NUMBER:  {this.props.loanissueobject.accountNumber} </h4>
                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}> ACCOUNT NAME:  {this.props.loanissueobject.accountName} </h4>

                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}> AMOUNT: <CurrencyFormat value={this.props.loanissueobject.approved_amount} displayType={'text'} thousandSeparator={true}/> UGX</h4>
                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}> PERIOD: {this.props.loanissueobject.loan_period} MONTHS</h4>
                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}>GRACE PERIOD: {this.props.loanissueobject.grace_period} DAYS</h4>

                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}>ANNUAL INTEREST RATE: {this.props.loanissueobject.interest_rate}</h4>
                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'end'}}> DATE OF ISSUANCE: {this.props.loanissueobject.date}</h4>

                  <reactstrp.Table bordered>
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>User</th>
                            <th>Desc</th>
                            <th>Principle Paid</th>
                            <th>Interest Paid</th>
                            <th>Fine Paid</th>
                            <th>Total Paid</th>
                            <th>Principle Balance</th>
                            <th>Interest Balance</th>
                            <th>Total Balance</th>
                     
                          </tr>
                        </thead>
                        <tbody>
                        {this.props.loanrepayments.map(
                          (item)=>(
                            <tr>
                            <td>{item.date}</td>
                            <td>{item.user==null?item.payment_by:item.user}</td>
                            <td>{item.description}</td>
                            <td>{<CurrencyFormat value={item.principle_paid} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td>{<CurrencyFormat value={item.interest_paid} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td>{<CurrencyFormat value={item.fine_paid} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td>{<CurrencyFormat value={item.total_paid} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td>{<CurrencyFormat value={item.principle_balance} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td>{<CurrencyFormat value={item.interest_balance} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td>{<CurrencyFormat value={item.loan_balance} displayType={'text'} thousandSeparator={true}/>}</td>
                            </tr>
                          ))}
                          <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td style={{fontWeight:'bold'}}>{<CurrencyFormat value={this.calculateTotalPrinciplePaid()} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td style={{fontWeight:'bold'}}>{<CurrencyFormat value={this.calculateTotalInterestPaid()} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td style={{fontWeight:'bold'}}>{<CurrencyFormat value={this.calculateTotalFinePaid()} displayType={'text'} thousandSeparator={true}/>}</td>

                          <td style={{fontWeight:'bold'}}>{<CurrencyFormat value={this.calculateTotalTotalPaid()} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td></td>
                          <td></td>
                          <td></td>
                        
                          </tr>

                      </tbody>
                  </reactstrp.Table>      

                                  <br></br>
                <h3>Generated by: {CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)}</h3>
                <h3>Powered by: www.pitech.co.ug</h3>    

    </div>
    );
  }
}



class LoanFines_Print extends React.Component {

  state = {
    companyprofile:{}
  };

  componentDidMount(){
    if(localStorage.getItem("sacco")){
      sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
   }else{
      sacco= ''
   }
   
   if(localStorage.getItem("token")){
      token= localStorage.getItem("token")
   }else{
      token= ''
   }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
    .then(res => {  
        this.setState({
          companyprofile: res.data
        })

    })

  }


   //calculate total fine paid
   calculateTotalFinePaid=()=>{
    var TotalPay=0
    this.props.loanrepayments.map(
      (item)=>{
        TotalPay+=Number(item.fine_paid)
      })

    return TotalPay.toFixed(2);
   }


    //calcultae cumulative fine
    calculateTotalcumulativefine=()=>{
    var TotalPay=0
    this.props.accumulated_fines.map(
      (item)=>{
        TotalPay+=Number(item.fine_attached)
      })

    return TotalPay.toFixed(2);
    }


  render() {
    return (
      <div style={{padding:20}}>
            
      <Row> 
                <Col xs="2" sm="2" lg="2">
                <img height="100" width="120"  alt="Logo" src={this.state.companyprofile.sacco_logo} />
              
                  </Col>
                  <Col xs="6" sm="6" lg="6">
                  <h3>{this.state.companyprofile.sacco_name}</h3>
                  <h6>Tel: {this.state.companyprofile.RegisteredPhoneNumber1}
                  {
                  this.state.companyprofile.RegisteredPhoneNumber2==""?
                  "":","+this.state.companyprofile.RegisteredPhoneNumber2
                  }
                  {
                  this.state.companyprofile.RegisteredPhoneNumber3==""?
                  "":","+this.state.companyprofile.RegisteredPhoneNumber3
                  }
                  </h6>               
                  <h5>Email: {this.state.companyprofile.company_email}</h5>
                  <h5>Wesite: {this.state.companyprofile.website}</h5>
                  <h5>{this.state.companyprofile.box_number}</h5>

                  </Col>

              </Row>
                  <h3 style={{fontWeight:'bolder',display: 'flex',justifyContent:'center', alignItems:'center'}}> CUMULATIVE FINES REPORT </h3>
                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}> LOAN NUMBER:  {this.props.loanissueobject.loan_number} </h4>

                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}> ACCOUNT NUMBER:  {this.props.loanissueobject.accountNumber} </h4>
                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}> ACCOUNT NAME:  {this.props.loanissueobject.accountName} </h4>

                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}> AMOUNT: <CurrencyFormat value={this.props.loanissueobject.approved_amount} displayType={'text'} thousandSeparator={true}/> UGX</h4>
                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}> PERIOD: {this.props.loanissueobject.loan_period} MONTHS</h4>
                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}>GRACE PERIOD: {this.props.loanissueobject.grace_period} DAYS</h4>

                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}>ANNUAL INTEREST RATE: {this.props.loanissueobject.interest_rate}</h4>
                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'end'}}> DATE OF ISSUANCE: {this.props.loanissueobject.date}</h4>


                  <reactstrp.Table bordered>
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Interest unpaid</th>
                            <th>Principle unpaid</th>
                            <th>Attached fine</th>

                          </tr>
                        </thead>
                        <tbody>
                        {this.props.accumulated_fines.map(
                          (item)=>(
                            <tr>
                            <td>{item.date}</td>
                            <td>{<CurrencyFormat value={item.unpaid_interest.toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td>{<CurrencyFormat value={item.unpaid_principle.toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td>{<CurrencyFormat value={item.fine_attached.toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>

                            </tr>
                          ))}
                          <tr>
                          <td>Total</td>
                          <td></td>
                          <td></td>

                          <td style={{fontWeight:'bold'}}>{<CurrencyFormat value={this.calculateTotalcumulativefine()} displayType={'text'} thousandSeparator={true}/>}</td>
                        
                          </tr>

                      </tbody>
                      </reactstrp.Table>

                     <br></br>
                <h3>Generated by: {CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)}</h3>
                <h3>Powered by: www.pitech.co.ug</h3>    

    </div>
    );
  }
}



class LoanExtras extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    loanissues: [],
    viewpaymentmodal:false,
    expensedetails:{},
    userprofile:{},
    datarequested:true,

    current_selected_loan:0,
    loan_particular_data_loading:false,

    loanschedule:[],
    loanissueobject:{},
    loanrepayments:[],
    companyprofile:{},
    loanfines:[],

    deletelist:[],
    totaltobepaidobject:{},
    interestpay:0,

    newreschdate:'',
    newreschamt:0,
    waiver_model_visible:false,
    
    
    schedule_edit_interest_value:0,
    schedule_edit_principe_value:0,
    schedule_edit_total_value:0,
    selected_scheduleobject:{},

    payment_model_visible:false,
    interest_paid:0,
    principle_paid:0,
    fine_paid:0,
    total_paid:0,
    interest_balance:0,
    principle_balance:0,
    total_balance:0,
    selected_paymentobject:{},

    accumulated_fines:[],
    fullypaid_loans: [],
    send_email_tonon_member:false,
    non_memberemailaddress:'',

    dateone:'',
    datetwo:'',
    userrights:{},
    current_txn_date:'',
    loanissueobject:{}

  };

  componentDidMount(){
    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
       bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
    
    }else{
       sacco= ''
       bizuserid= ''
    
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    let form_data = new FormData();
    form_data.append('userid', bizuserid);
    
    //get the user profile here
    axios.post(serverconfig.backendserverurl+'/customqueries/get_user_profile',form_data,{
      headers: {
        'content-type': 'multipart/form-data'
      }
      })
    .then(res => {
        this.setState({
          userprofile:res.data
        })
    })



    axios.get(serverconfig.backendserverurl+`/api/accountrights/?user=${bizuserid}`)
    .then(res => {
        this.setState({
          userrights:res.data[0]
        })
    })


    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
    .then(res => {  
        this.setState({
          companyprofile: res.data
        })

    })


    this.setState({loan_particular_data_loading:true})
    //set curent id
    this.setState({current_selected_loan:this.props.loanissueID})
    var loanissueID=this.props.loanissueID

    //get other data
    axios.get(`${serverconfig.backendserverurl}/api/loanissues/${loanissueID}`)
    .then(res => {  
        this.setState({loanissueobject: res.data})
        this.setState({newreschdate:res.data.date})
        this.setState({newreschamt:res.data.approved_amount})
       })

    axios.get(`${serverconfig.backendserverurl}/api/loanschedules/?loanissue=${loanissueID}`)
    .then(res => {  
        this.setState({loanschedule: res.data})
    })

    axios.get(`${serverconfig.backendserverurl}/api/loanrepayments_viewonly/?loanissue=${loanissueID}`)
    .then(res => {  
        this.setState({loanrepayments: res.data})
    })

    //get acculated fines
    axios.get(serverconfig.backendserverurl+`/customqueries/getloanfines/${loanissueID}`,{
      headers: {
        'content-type': 'multipart/form-data'
      }
      })
    .then(res =>{
      console.log(res.data)
      this.setState({accumulated_fines:JSON.parse(res.data.report)})
      this.setState({loan_particular_data_loading:false})
      this.setState({datarequested:false})

    } 
    )
    .catch(error => console.log(error)) 




}


  //calculate principleTotal
  calculateScheduleTotal=()=>{
    var principleTotal=0
    this.state.loanschedule.map(
      (item)=>{
        principleTotal+=Number(item.principle)
      })

    return principleTotal.toFixed(2);
  }

    //calculate principleTotal
    calculateInterestTotal=()=>{
      var InterestTotal=0
      this.state.loanschedule.map(
        (item)=>{
          InterestTotal+=Number(item.interest)
        })
  
      return InterestTotal.toFixed(2);
    }

    //calculate principleTotal
    calculateTotalPay=()=>{
      var TotalPay=0
      this.state.loanschedule.map(
        (item)=>{
          TotalPay+=Number(item.total)
        })
  
      return TotalPay.toFixed(2);
    }


      //calculate principle paid
      calculateTotalPrinciplePaid=()=>{
      var TotalPay=0
      this.state.loanrepayments.map(
        (item)=>{
          TotalPay+=Number(item.principle_paid)
        })
  
      return TotalPay.toFixed(2);
     }
  
      //calculate Interest paid
      calculateTotalInterestPaid=()=>{
        var TotalPay=0
        this.state.loanrepayments.map(
          (item)=>{
            TotalPay+=Number(item.interest_paid)
          })
    
        return TotalPay.toFixed(2);
       }

             //calculate Total total paid
      calculateTotalTotalPaid=()=>{
        var TotalPay=0
        this.state.loanrepayments.map(
          (item)=>{
            TotalPay+=Number(item.total_paid)
          })
    
        return TotalPay.toFixed(2);
       }

       //calculate total fine paid
       calculateTotalFinePaid=()=>{
        var TotalPay=0
        this.state.loanrepayments.map(
          (item)=>{
            TotalPay+=Number(item.fine_paid)
          })
    
        return TotalPay.toFixed(2);
       }


      //calculate total fine paid
      calculateTotaldailyFine=()=>{
        var TotalPay=0
        this.state.loanfines.map(
          (item)=>{
            TotalPay+=Number(item.cyclefine)
          })
    
        return TotalPay.toFixed(2);
        }

        //calcultae cumulative fine
        calculateTotalcumulativefine=()=>{
          var TotalPay=0
          this.state.accumulated_fines.map(
            (item)=>{
              TotalPay+=Number(item.fine_attached)
            })
      
          return TotalPay.toFixed(2);
          }


    //////////////////////////////////////////////////
  //handle delete here
  handleDelete = id => {
      let form_data = new FormData();
      form_data.append('loanid', id);
      form_data.append('sacco',sacco);
      form_data.append('user',bizuserid);

      axios.post(serverconfig.backendserverurl+'/customqueries/deleteloan', form_data, {
        headers: {
          'content-type': 'multipart/form-data'
        }
      })
    .then(res => window.location.reload(false),message.info('Success fully deleted Loan')
    )
    .catch(error => console.log(error))
   
  };


getColumnSearchProps = dataIndex => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <Input
        ref={node => {
          this.searchInput = node;
        }}
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        style={{ width: 188, marginBottom: 8, display: 'block' }}
      />
      <Button
        type="primary"
        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        icon={<SearchOutlined />}
        size="small"
        style={{ width: 90, marginRight: 8 }}
      >
        Search
      </Button>
      <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
        Reset
      </Button>
    </div>
  ),
  filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
  onFilter: (value, record) =>
    record[dataIndex]
      .toString()
      .toLowerCase()
      .includes(value.toLowerCase()),
  onFilterDropdownVisibleChange: visible => {
    if (visible) {
      setTimeout(() => this.searchInput.select());
    }
  },
  render: text =>
    this.state.searchedColumn === dataIndex ? (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ) : (
      text
    ),
});

handleSearch = (selectedKeys, confirm, dataIndex) => {
  confirm();
  this.setState({
    searchText: selectedKeys[0],
    searchedColumn: dataIndex,
  });
};

handleReset = clearFilters => {
  clearFilters();
  this.setState({ searchText: '' });
};

  render() {

  
    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
              <Spin size="large">
                <div className="content" />
              </Spin>       
        </div>
      )

    }else{
      return(
        <div>
            <div style={{display: "none"}}>
            &nbsp;&nbsp;
            <ReceiptToPrint
            loanschedule={this.state.loanschedule} 
            date={this.state.datetoday} 
            loanissueobject={this.state.loanissueobject}
            ref={el => (this.componentRef = el)} /> 
            </div>


            <div style={{display: "none"}}>
            &nbsp;&nbsp;
            <StatementToPrint
            loanrepayments={this.state.loanrepayments} 
            date={this.state.datetoday} 
            loanissueobject={this.state.loanissueobject}
            ref={sel => (this.componentReftwo = sel)} /> 
            </div>

            <div style={{display: "none"}}>
            &nbsp;&nbsp;
            <LoanFines_Print
            accumulated_fines={this.state.accumulated_fines} 
            date={this.state.datetoday} 
            loanissueobject={this.state.loanissueobject}
            ref={el => (this.componentRef_fines = el)} /> 
            </div>


            {
                this.state.loan_particular_data_loading===true?
                <div style={{display:'flex',margin:20}}>
                <Spin indicator={antIcon} />
                </div>
                :

                <Tabs defaultActiveKey="1" onChange={callback}>
                
                <TabPane tab="Loan Statement" key="03" >
                    <div style={{display:'flex',}}>

                        <a>
                        <ReactToPrint
                        trigger={() =>                     
                            <div style={{}}>
                            <Tooltip title="Click to print" placement="top">
                            <p style={{alignSelf:'center'}}><PrinterOutlined style={{ fontSize: '40px', color: '#08c' }}/></p>
                            <h6 style={{alignSelf:'center'}}>Print </h6>
                            </Tooltip>
                            </div>                          
                            }
                            content={() => this.componentReftwo}
                            />  
                        </a>


                    &nbsp;
                    &nbsp;
                    &nbsp;
                    &nbsp;
                    &nbsp;
                    <div style={{display:'flex',flexDirection:'column',marginBottom:6}}>
                                            
                    <FormItem label="Send to non members">
                    <Switch
                            checked={this.state.send_email_tonon_member}
                            onChange={val=>{this.setState({send_email_tonon_member:!this.state.send_email_tonon_member})}}
                            checkedChildren="ON"
                            unCheckedChildren="OFF"
                        />
                    </FormItem>
        
                    {
                        this.state.send_email_tonon_member?
                        <FormItem label="Email address">
                        <Input type={'email'} placeholder="Put email here." value={this.state.non_memberemailaddress} onChange={(val)=>{this.setState({non_memberemailaddress:val.target.value})}} />
                        </FormItem>
                        :
                        null
                    }

                    <Button type='primary'
                        icon={<MailFilled/>}
                        
                        onClick={
                        ()=>{
                            
                        if(this.state.send_email_tonon_member===true && this.state.non_memberemailaddress===""){
                        message.error("Please enter non member email address")
                        }else{

                        let form_data = new FormData();
                        form_data.append('loanid', this.state.loanissueobject.id);
                        form_data.append('sacco', sacco);
                        form_data.append('send_email_tonon_member', this.state.send_email_tonon_member);
                        form_data.append('non_memberemailaddress', this.state.non_memberemailaddress);

                        console.log(this.state.entrant)
                            
                        this.setState({datarequested:true})
                
                        //Now submit sale data to database
                        axios.post(serverconfig.backendserverurl+'/customqueries/emailloanstatement', form_data,{
                        headers: {
                            'content-type': 'multipart/form-data'
                        }
                        })
                        .then(res =>{
                            this.setState({datarequested:false})
                            message.info(res.data.message)
                        } 
                        )
                        .catch(error => console.log(error)) 
                        }

                        
                    }}
                        
                        >
                        Send via eMail

                        </Button>
                        </div>
                        &nbsp; &nbsp;



                    <ExcelFile  
                    filename={"Loan statement for "+this.state.loanissueobject.accountName+"_loan number "+this.state.loanissueobject.loan_number}
                    element={<Button type='primary' 
                    icon={<DownloadOutlined/>} 
                    style={{margin:10}}

                    >Download Excel report</Button>}>
                    <ExcelSheet data={this.state.loanrepayments} name={"LOAN STATEMENT"}>
                        <ExcelColumn label="Date" value="date"/>
                        <ExcelColumn label="User" value="user"/>
                        <ExcelColumn label="Desc" value="description"/>
                        <ExcelColumn label="Principle paid" value="principle_paid"/>
                        <ExcelColumn label="Interest paid" value="interest_paid"/>
                        <ExcelColumn label="Fine paid" value="fine_paid"/>
                        <ExcelColumn label="Total paid" value="total_paid"/>

                        <ExcelColumn label="Principle" value="principle_balance"/>
                        <ExcelColumn label="Interest balance" value="interest_balance"/>
                        <ExcelColumn label="Total balance" value="loan_balance"/>

                    </ExcelSheet>
                </ExcelFile>

                    </div>


                <reactstrp.Table bordered>
                <thead>
                    <tr>
                    <th>Date</th>
                    <th>User</th>
                    <th>Desc</th>
                    <th>Principle Paid</th>
                    <th>Interest Paid</th>
                    <th>Fine Paid</th>
                    <th>Total Paid</th>
                    <th>Principle Balance</th>
                    <th>Interest Balance</th>
                    <th>Total Balance</th> 

                    </tr>
                </thead>
                <tbody>
                {this.state.loanrepayments.map(
                    (item)=>(
                    <tr>
                    <td>{item.date}</td>
                    <td>{item.user==null?item.payment_by:item.user}</td>
                    <td>{item.description}</td>
                    <td>{<CurrencyFormat value={item.principle_paid} displayType={'text'} thousandSeparator={true}/>}</td>
                    <td>{<CurrencyFormat value={item.interest_paid} displayType={'text'} thousandSeparator={true}/>}</td>
                    <td>{<CurrencyFormat value={item.fine_paid} displayType={'text'} thousandSeparator={true}/>}</td>
                    <td>{<CurrencyFormat value={item.total_paid} displayType={'text'} thousandSeparator={true}/>}</td>
                    <td>{<CurrencyFormat value={item.principle_balance} displayType={'text'} thousandSeparator={true}/>}</td>
                    <td>{<CurrencyFormat value={item.interest_balance} displayType={'text'} thousandSeparator={true}/>}</td>
                    <td>{<CurrencyFormat value={item.loan_balance} displayType={'text'} thousandSeparator={true}/>}</td>
                    
                    
                    </tr>
                    ))}
                    <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td style={{fontWeight:'bold'}}>{<CurrencyFormat value={this.calculateTotalPrinciplePaid()} displayType={'text'} thousandSeparator={true}/>}</td>
                    <td style={{fontWeight:'bold'}}>{<CurrencyFormat value={this.calculateTotalInterestPaid()} displayType={'text'} thousandSeparator={true}/>}</td>
                    <td style={{fontWeight:'bold'}}>{<CurrencyFormat value={this.calculateTotalFinePaid()} displayType={'text'} thousandSeparator={true}/>}</td>
                    <td style={{fontWeight:'bold'}}>{<CurrencyFormat value={this.calculateTotalTotalPaid()} displayType={'text'} thousandSeparator={true}/>}</td>

                    <td></td>
                    <td></td>
                    <td></td>
                
                
                    </tr>

                </tbody>
                </reactstrp.Table>

                </TabPane>
                
                
                <TabPane tab="Loan Schedule" key="02" >

                    <div style={{display:'flex',flexDirection:'row'}}>
                    <a style={{margin:10}}>
                    <ReactToPrint
                        trigger={() =>                     
                    <div style={{}}>
                        <Tooltip title="Click to print" placement="top">
                        <p style={{alignSelf:'center'}}><PrinterOutlined style={{ fontSize: '40px', color: '#08c' }}/></p>
                        <h6 style={{alignSelf:'center'}}>Print </h6>
                        </Tooltip>
                    </div>                          
                        }
                        content={() => this.componentRef}
                    />  
                    </a>


                    <Button type='primary'
                    icon={<MailFilled/>}
                    
                    onClick={
                    ()=>{
                        let form_data = new FormData();
                        form_data.append('loanid', this.state.loanissueobject.id);
                        form_data.append('sacco', sacco);
                        
                        console.log(this.state.entrant)
                        
                        this.setState({datarequested:true})
                
                        //Now submit sale data to database
                        axios.post(serverconfig.backendserverurl+'/customqueries/email_loanschedule', form_data,{
                        headers: {
                        'content-type': 'multipart/form-data'
                        }
                        })
                        .then(res =>{
                        this.setState({datarequested:false})
                        message.info(res.data.message)
                        } 
                        )
                        .catch(error => console.log(error))   
                        
                    }
                    }
                    
                    style={{margin:10}}
                    >
                    Send via eMail

                    </Button>

                    <ExcelFile  
                    filename={"Loan schedule for "+this.state.loanissueobject.accountName+"_loan number "+this.state.loanissueobject.loan_number}
                    element={<Button type='primary' 
                    icon={<DownloadOutlined/>} 
                    style={{margin:10}}

                    >Download Excel report</Button>}>
                    <ExcelSheet data={this.state.loanschedule} name={"LOAN SCHEDULE"}>
                        <ExcelColumn label="#" value="repayment_number"/>
                        <ExcelColumn label="Date" value="date"/>
                        <ExcelColumn label="Principle Bf" value="principlebroughtforward"/>
                        <ExcelColumn label="Principle Pay" value="principle"/>
                        <ExcelColumn label="Interest Pay" value="interest"/>
                        <ExcelColumn label="Total Pay" value="total"/>
                        <ExcelColumn label="Principle Bal" value="balance"/>

                    </ExcelSheet>
                </ExcelFile>

                    </div>


                    <br></br>


                    
                    <reactstrp.Table bordered>
                    <thead>

                    <tr>
                        <th>#</th>

                        { 
                        this.state.companyprofile.allow_transaction_reversal && this.state.userrights.can_make_transaction_reversals?
                        <th>Action</th>
                        :
                        null
                        }

                        <th>Date</th>
                        <th>Principle Bf</th>
                        <th>Principle Pay</th>
                        <th>Interest Pay</th>
                        <th>Total Pay</th>
                        <th>Principle Bal</th>
            

                    </tr>
                    </thead>
                    <tbody>
                    {this.state.loanschedule.map(
                    (item)=>(
                        <tr>
                        <td>{item.repayment_number}</td>

                        { 
                        this.state.companyprofile.allow_transaction_reversal && this.state.userrights.can_make_transaction_reversals?
                        <td>
                            <Tooltip title="Click to edit interest (waive)" placement="top">
                            <EditOutlined style={{color:'blue'}}
                            onClick={()=>{

                        this.setState({schedule_edit_interest_value:item.interest})

                        this.setState({selected_scheduleobject:item})
                        this.setState({waiver_model_visible:true})
                        
                        }}
                        />
                        </Tooltip>
                    </td>
                    :
                    null}


                        <td>{item.date}</td>
                        <td>{<CurrencyFormat value={item.principlebroughtforward} displayType={'text'} thousandSeparator={true}/>}</td>
                        <td>{<CurrencyFormat value={item.principle} displayType={'text'} thousandSeparator={true}/>}</td>
                        <td>{<CurrencyFormat value={item.interest} displayType={'text'} thousandSeparator={true}/>}</td>
                        <td>{<CurrencyFormat value={item.total} displayType={'text'} thousandSeparator={true}/>}</td>
                        <td>{<CurrencyFormat value={item.balance} displayType={'text'} thousandSeparator={true}/>}</td>
                    
                    
                        </tr>
                    ))}
                    <tr>
                    <td></td>
                    { 
                        this.state.companyprofile.allow_transaction_reversal && this.state.userrights.can_make_transaction_reversals?
                        <td></td>
                        :
                        null
                    }
                    <td></td>
                    <td></td>
                    <td style={{fontWeight:'bold'}}>{<CurrencyFormat value={this.calculateScheduleTotal()} displayType={'text'} thousandSeparator={true}/>}</td>
                    <td style={{fontWeight:'bold'}}>{<CurrencyFormat value={this.calculateInterestTotal()} displayType={'text'} thousandSeparator={true}/>}</td>
                    <td style={{fontWeight:'bold'}}>{<CurrencyFormat value={this.calculateTotalPay()} displayType={'text'} thousandSeparator={true}/>}</td>
                    <td></td>
                    </tr>

                </tbody>
                </reactstrp.Table>
        
                </TabPane>




                <TabPane tab="Repayment" key="04" >
                    <LoanRepaymentDirectViewList loan_id={this.props.loanissueID} />

                </TabPane>

                <TabPane tab="Loan accumulated fines" key="01" >
                    <Card>
                    <div style={{display:'flex',}}>
                <a>
                <ReactToPrint
                    trigger={() =>                     
                    <div style={{}}>
                        <Tooltip title="Click to print" placement="top">
                        <p style={{alignSelf:'center'}}><PrinterOutlined style={{ fontSize: '40px', color: '#08c' }}/></p>
                        <h6 style={{alignSelf:'center'}}>Print report </h6>
                        </Tooltip>
                    </div>                          
                        }
                        content={() => this.componentRef_fines}
                    />  
                </a>

                    </div>
                    <br></br>
                    <br></br>

                    <reactstrp.Table bordered>
                <thead>
                    <tr>
                    <th>Date</th>
                    <th>Interest unpaid</th>
                    <th>Principle unpaid</th>
                    <th>Attached fine</th>

                    </tr>
                </thead>
                <tbody>
                {this.state.accumulated_fines.map(
                    (item)=>(
                    <tr>
                    <td>{item.date}</td>
                    <td>{<CurrencyFormat value={item.unpaid_interest.toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>
                    <td>{<CurrencyFormat value={item.unpaid_principle.toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>
                    <td>{<CurrencyFormat value={item.fine_attached.toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>

                    </tr>
                    ))}
                    <tr>
                    <td>Total</td>
                    <td></td>

                    <td></td>

                    <td style={{fontWeight:'bold'}}>{<CurrencyFormat value={this.calculateTotalcumulativefine()} displayType={'text'} thousandSeparator={true}/>}</td>
                
                    </tr>

                </tbody>
                </reactstrp.Table>

                <br></br>
                <br></br>
                <LoanFineAttachmentForm loan_id={this.state.loanissueobject.id} />

                </Card>

                </TabPane>

                {
                    this.state.companyprofile.allow_transaction_reversal && this.state.userrights.can_make_transaction_reversals?
                    <TabPane tab="Update loan date" key="0001" >
                    <LoanDateUpdateForm current_selected_loan={this.state.loanissueobject.id} />          
                    </TabPane>

                    :
                    null
                }     


                {
                    this.state.companyprofile.allow_transaction_reversal && this.state.userrights.can_make_transaction_reversals?
                    <TabPane tab="Interest Waiving" key="00001" >
                    <LoanInterestWaivingForm_MultiCycles loanobj={this.state.loanissueobject} />
                    </TabPane>
                    :
                    null
                }


                {
                    this.state.companyprofile.allow_transaction_reversal && this.state.userrights.can_make_transaction_reversals ?
                    <TabPane tab="Bad Loan PayOff" key="000001" >
                    
                    <LoanBadDebtPayOffForm loan_id={this.props.loanissueID} />

                    {/*
                    record.status==="matured"?
                    :
                    <p style={{color:'green'}}>Loan Not yet mature.</p>
                    */
                    }

                    </TabPane>
                    :
                    null
                }


                <TabPane tab="Quick Actions" key="000111" >
                <LoanQuickActions loan_id={this.state.loanissueobject.id} />
                </TabPane>

                </Tabs>
            }



             {
              this.state.waiver_model_visible?
              <Modal              
              visible={this.state.waiver_model_visible}
              title={"Interest waiver form"}
              onCancel={()=>{this.setState({waiver_model_visible:false})}}
              style={{width:1000}}
              footer={[
                <Button key="back" onClick={()=>{this.setState({waiver_model_visible:false})}}>
                  Cancel
                </Button>
                ]}
                >

                  <LoanInterestWaiverForm  selected_scheduleobject={this.state.selected_scheduleobject}   />
              
              </Modal> 
              :
              null
             } 
            

               <Modal              
              visible={this.state.payment_model_visible}
              title={"Loan payment edit form"}
              onCancel={()=>{this.setState({payment_model_visible:false})}}
              style={{width:1000}}
              footer={[
                <Button key="back" onClick={()=>{this.setState({payment_model_visible:false})}}>
                  Cancel
                </Button>,
                  <Button key="ok" type='primary' 
                    onClick={()=>{

                        let form_data = new FormData();
                        form_data.append('payment_id', this.state.selected_paymentobject.id);
                        form_data.append('interest_paid', this.state.interest_paid);
                        form_data.append('principle_paid', this.state.principle_paid);
                        form_data.append('fine_paid', this.state.fine_paid);
                        form_data.append('interest_balance', this.state.interest_balance);
                        form_data.append('principle_balance', this.state.principle_balance);
                        form_data.append('total_balance', this.state.total_balance);

                        axios.post(serverconfig.backendserverurl+`/customqueries/loanpayment_editing`, form_data, {
                          headers: {
                            'content-type': 'multipart/form-data'
                          }
                        })
                      .then(res => {
                        if(res.data.message=="success"){
                          message.info(res.data.message)
                          this.setState({datarequested:false})
                          window.location.reload(false)
                    
                        }else{
                          message.info("Some thing went wrong")
                        }
                    
                      } )
                      .catch(error => console.log(error))
                      this.setState({payment_model_visible:false})

                    }}>
                  Update
                </Button>
                ]}
                >
                  
                <FormItem label="Interest paid" >
                    <Input name="interest_paid"  placeholder="Interest paid" value={this.state.interest_paid} onChange={(val)=>{this.setState({interest_paid:val.target.value})}} />
                </FormItem>             

                <FormItem label="Principle paid" >
                    <Input name="principle_paid"  placeholder="Principle paid" value={this.state.principle_paid} onChange={(val)=>{this.setState({principle_paid:val.target.value})}} />
                </FormItem>      
        
                <FormItem label="Fine paid" >
                    <Input name="fine_paid"  placeholder="Fine paid" value={this.state.fine_paid} onChange={(val)=>{this.setState({fine_paid:val.target.value})}} />
                </FormItem>    

                <FormItem label="Interest balance" >
                    <Input name="interest_balance"  placeholder="Interest balance" value={this.state.interest_balance} onChange={(val)=>{this.setState({interest_balance:val.target.value})}} />
                </FormItem>  

                <FormItem label="Principle balance" >
                    <Input name="principle_balance"  placeholder="Principle balance" value={this.state.principle_balance} onChange={(val)=>{this.setState({principle_balance:val.target.value})}} />
                </FormItem> 

                <FormItem label="Total balance" >
                    <Input name="total_balance"  placeholder="Total balance" value={this.state.total_balance} onChange={(val)=>{this.setState({total_balance:val.target.value})}} />
                </FormItem>  

               </Modal>
        </div>  )

    }
    
  }
}

export default LoanExtras; 
